import { render } from "./LogbookPanel.vue?vue&type=template&id=b0da8cca&scoped=true"
import script from "./LogbookPanel.vue?vue&type=script&lang=js"
export * from "./LogbookPanel.vue?vue&type=script&lang=js"

import "./LogbookPanel.vue?vue&type=style&index=0&id=b0da8cca&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0da8cca"]])

export default __exports__